export default "__VITE_ASSET__CdCxsneQ__"